//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
// Material ui Imports

import { Grid, Tooltip, Typography } from "@mui/material";
import { EDragContentOptions } from "../../models/hotspotDrag.models";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { IDragOptions } from "../../models/current.models";
import { AddRounded, DeleteRounded } from "@mui/icons-material";

// Custom components imports (and hooks and helpers)
// Media imports

//---------------------------------------------------------------------------------------------------
// ## MUI STYLED ##
// Layout stuff remains inline, other styling pulled into it's own components

//---------------------------------------------------------------------------------------------------
// ## INTERFACES ##
interface IProps {
    item: any;
    organisation: any;
    localHandleDrag: any;
    handleDoubleClick: (mediaType: EDragContentOptions, src: string, preview?: string) => void;
    addFunction?: any;
    deleteFunction?: any;
}

//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Only display layouts in pages
export default function VTImmersiveVideoDraggable({
    item,
    organisation,
    localHandleDrag,
    handleDoubleClick,
    addFunction,
    deleteFunction,
}: IProps) {
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##

    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##

    const [dragging, setDragging] = useState<boolean>(false);
    const [hover, setHover] = useState<boolean>(false);
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##

    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##

    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    // Render for the tab buttons
    function textCutOffAddElipsis(text: string, cutOffPointCharIndex: number) {
        const charAtIndex = text.charAt(cutOffPointCharIndex);
        if (charAtIndex === " ") {
            return text.substring(0, cutOffPointCharIndex) + "...";
        } else if (charAtIndex === "") {
            return text;
        } else {
            return text.substring(0, cutOffPointCharIndex + 1) + "...";
        }
    }

    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    // Show creator page tabs options
    return (
        <Grid
            item
            key={item.id}
            xs={6}
            sx={{
                padding: "5px",
                height: "200px",
                position: "relative",
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {hover && (
                <>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            position: "absolute",
                            top: 5,
                            left: 5,
                            right: 5,
                            borderRadius: "5px 5px 0px 0px",
                            userSelect: "none",
                            height: "35px",
                            backgroundColor: "rgba(22,22,22,0.8)",
                        }}
                    >
                        <Typography
                            sx={{
                                marginLeft: "5px",
                                marginTop: "5px",
                            }}
                        >
                            {item && item.name && item.name?.length > 14
                                ? textCutOffAddElipsis(item.name, 14)
                                : item.name}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            position: "absolute",
                            top: 57,
                            right: 10,
                            userSelect: "none",
                            height: "35px",
                            zIndex: 10000,
                        }}
                    >
                        {deleteFunction && (
                            <Tooltip title={"Delete from scenario media"}>
                                <DeleteRounded
                                    onClick={deleteFunction}
                                    sx={{
                                        backgroundColor: "rgba(22,22,22,0.8)",
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                    }}
                                />
                            </Tooltip>
                        )}
                        {addFunction && (
                            <Tooltip title={"Add to your media"}>
                                <AddRounded
                                    onClick={addFunction}
                                    sx={{
                                        backgroundColor: "rgba(22,22,22,0.8)",
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                    }}
                                />
                            </Tooltip>
                        )}
                    </Grid>
                </>
            )}
            <img
                // TODO: change to media type
                // src={`${process.env.REACT_APP_NINJA_MEDIA}/${organisation}/three_sixty_video/${item.id}/${item.id}_preview.png`}
                src={`${process.env.PUBLIC_URL}/images/360_video_default_image.png`}
                alt={item.name}
                loading="lazy"
                style={{
                    objectFit: "cover",
                    borderRadius: "5px",
                    cursor: "pointer",
                    height: "155px",
                    width: "170px",
                    zIndex: 1,
                    position: "absolute",
                    top: "5px",
                    left: "5px",
                    right: "5px",
                    opacity: dragging ? 1 : 0,
                }}
                draggable={true}
                onDragStart={() => {
                    localHandleDrag(
                        true,
                        EDragContentOptions.VIDEO_360,
                        `${process.env.REACT_APP_NINJA_MEDIA}/${organisation}/three_sixty_video/${item.id}/${item.id}.${item.filetype}`,
                    );
                    setDragging(true);
                }}
                onDragEnd={() => {
                    localHandleDrag(false);
                    setDragging(false);
                }}
                onDoubleClick={() =>
                    handleDoubleClick(
                        EDragContentOptions.VIDEO_360,
                        `${process.env.REACT_APP_NINJA_MEDIA}/${organisation}/three_sixty_video/${item.id}/${item.id}.${item.filetype}`,
                    )
                }
            />

            <ReactPlayer
                url={`${process.env.REACT_APP_NINJA_MEDIA}/${organisation}/three_sixty_video/${item.id}/${item.id}.${item.filetype}`}
                controls
                width={"170px"}
                height={"190px"}
                style={{
                    borderRadius: "5px",
                    height: "100px",
                    zIndex: 1,
                }}
            />
        </Grid>
    );
}
